import {Engine} from '../models/engine/engine.model';
import {JobEngine} from '../models/engine/jobEngine.model';

export namespace Engines {
  export class GetEngines {
    static readonly type = '[Engine api] GetEngines';

    constructor(public force: boolean = false) {
    }
  }

  export class GetEngine {
    static readonly type = '[Engines api] GetEngine';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateEngine {
    static readonly type = '[Engines api] CreateEngine';

    constructor(public engine: Engine) {
    }
  }

  export class UpdateEngine {
    static readonly type = '[Engines api] Update Engine';

    constructor(public engine: Engine) {
    }
  }

  export class DeleteEngine {
    static readonly type = '[Engines api] Delete Engine';

    constructor(public engine: Engine) {
    }
  }

  export class GetJobEngine {
    static readonly type = '[Engines api] GetJobEngine';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateJobEngine {
    static readonly type = '[Engines api] UpdateJobEngine';

    constructor(public jobEngine: JobEngine) {
    }
  }

  export class SelectJobEngine {
    static readonly type = '[Engines api] SelectJobEngine';

    constructor(public engine: Engine) {
    }
  }
}
